
import { defineComponent } from 'vue';
import Exception from '@/components/exception';

export default defineComponent({
  components: {
    Exception,
  },
});
